/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { Component, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordFieldComponent } from '../password-field/password-field.component';
import { DataFieldComponentBase } from './datafield-base-component';
import { CurrentUserService } from '../../user/services/current-user.service';
import { DataField } from './models/datafield';
import { User } from '../../user/models/user';

@Component({
    selector: 'ep-datafield-password',
    templateUrl: './datafield-password.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'], // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, PasswordFieldComponent]
})

export class DataFieldPasswordComponent extends DataFieldComponentBase implements OnChanges {

    public canShowPassword = false;

    constructor(private currentUserService: CurrentUserService) {
        super();
        this.currentUserService.userChangedObserver.subscribe(() => this.checkPermission());
    }

    override ngOnChanges(changes: any) {
        if (changes.datafield && changes.datafield.firstChange) {
            DataField.RemapSecret(this.datafield);
        }
    }

    checkPermission() {
        let currentUser = this.currentUserService.getCurrentUser();
        if (currentUser) {
            this.canShowPassword = User.hasPermission('ShowPasswords', currentUser);
        }
    }

    onValueChange($event: string): void {
        this.datafield.Value = $event;
        this.notifyValueChanged(this.datafield);
    }

    onCleared() {
        this.datafield.Value = '';
        this.datafield.SecretId = '';
        this.notifyValueChanged(this.datafield);
    }

    get isValid() {
        const fc = this.formValidationGroup.controls[this.validationIdentifier];

        if (this.formValidationGroup.disabled || fc?.disabled === true) {
            return true;
        }

        fc.updateValueAndValidity();
        return fc.valid;
    }

    get errorText() {
        if (this.formValidationGroup.disabled) {
            return '';
        }

        if (this.formValidationGroup.controls[this.validationIdentifier].hasError('required')) {
            return 'This field is required';
        }

        if (this.formValidationGroup.controls[this.validationIdentifier].hasError('minlength')) {
            return 'Password must be at least 8 characters long';
        }

        if (this.formValidationGroup.controls[this.validationIdentifier].hasError('pattern')) {
            return this.datafield.RegExErrorMessage || `Invalid pattern - must match: ${this.datafield.RegEx}`; // If not error-message is given - use a generic error message...
        }

        return 'Unknown error';
    }

}
